module.exports = {
  "country": "UK",
  "artist": "Javine",
  "song": "Touch My Fire",
  "year": "2005",
  "place": "22",
  "spotify": "21nezKdKdlphStdxgpwg5H"
};